var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConsolidatedHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.64506 6.4043L0.76214 6.40465C0.620063 6.40465 0.463599 6.41977 0.323433 6.39867C0.0391663 6.35588 -0.0967286 5.93878 0.0773832 5.71031C0.15584 5.60738 0.258464 5.52274 0.353219 5.43658L5.45428 0.842519C5.60962 0.705127 5.75046 0.526002 5.96459 0.500916C6.21772 0.477822 6.58246 0.897851 6.76478 1.05681L11.6578 5.42837C11.7243 5.48781 11.7941 5.54408 11.8589 5.6055C12.1059 5.83961 12.0176 6.29504 11.6766 6.37136C11.5321 6.40371 11.3603 6.38425 11.2126 6.38425L10.3608 6.38378C10.3507 6.76606 10.3608 7.15186 10.3608 7.5345L10.3613 10.6931C10.3621 11.4056 10.3156 11.4997 9.67669 11.5L7.13211 11.4997L7.13391 7.97012C7.13594 7.48925 6.91439 7.48807 6.53705 7.48843L6.04136 7.48901L5.4971 7.48843C4.93138 7.48819 4.87349 7.49909 4.87383 8.14713L4.87417 11.4997L2.33477 11.5C1.61876 11.4997 1.64439 11.3364 1.64473 10.5953L1.64495 6.4043H1.64506Z",
    fill: "#26890D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsolidatedHome);
export default __webpack_public_path__ + "static/media/consolidated-home.e7e59c1bd320d12c72bd7007d95cbcc8.svg";
export { ForwardRef as ReactComponent };